// Module
var code = "<div> <div ng-if=\"vm.hasMore\"> <div class=\"btn-group btn-group-justified\"> <div class=\"btn-group\"> <button class=\"btn btn-default more\" ng-click=\"vm.more()\"> <i class=\"fa fa-fw\" ng-class=\"vm.icon\" ng-if=\"vm.icon\"></i> {{(vm.text ? vm.text : 'More')|translate}}... </button> </div> </div> </div> </div>";
// Exports
module.exports = code;